import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { getPages } from '../api/pagesApi';
import { PagesList } from '../components/dashboard/PagesList';
import { partitionPages } from '../utils/pageGroups';

const WealthDetailPagesPage = () => {
  const [wealthDetailPages, setWealthDetailPages] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    let isMounted = true;

    const load = async () => {
      try {
        const loadedPages = await getPages();
        if (!isMounted) {
          return;
        }

        const { wealthDetailPages: pages } = partitionPages(loadedPages);
        setWealthDetailPages(pages);
        setError('');
      } catch (err) {
        if (!isMounted) {
          return;
        }

        setWealthDetailPages([]);
        setError(err.message || 'Failed to load pages.');
      } finally {
        if (isMounted) {
          setIsLoading(false);
        }
      }
    };

    load();

    return () => {
      isMounted = false;
    };
  }, []);

  if (isLoading) {
    return <p className="text-sm text-[#6b635c]">Loading wealth product pages…</p>;
  }

  if (error) {
    return (
      <div className="space-y-4">
        <p className="rounded-md border border-red-200 bg-red-50 px-3 py-2 text-sm text-red-700">
          {error}
        </p>
        <Link
          to="/dashboard/pages"
          className="inline-flex text-sm font-medium text-[#785E32] hover:underline"
        >
          Back to pages
        </Link>
      </div>
    );
  }

  return (
    <div className="mx-auto max-w-3xl">
      <header className="mb-6 border-b border-[#e4d9c8] pb-5">
        <Link
          to="/dashboard/pages"
          className="text-[12px] font-medium text-[#785E32] hover:underline"
        >
          ← All pages
        </Link>
        <p className="mt-3 text-[12px] font-medium uppercase tracking-[0.16em] text-[#6b635c]">
          Page group
        </p>
        <h2 className="mt-2 font-[Merriweather] text-[1.5rem] text-[#130705]">
          Wealth product pages
        </h2>
        <p className="mt-2 max-w-2xl text-sm leading-relaxed text-[#6b635c]">
          Open a wealth product page to edit its hero, earn section, core parameters, and more.
        </p>
      </header>

      <PagesList
        pages={wealthDetailPages}
        emptyMessage="No wealth product pages found. Restart the backend to seed them."
      />
    </div>
  );
};

export default WealthDetailPagesPage;
